module.exports = __webpack_public_path__ + "static/media/plant-based.46c19fe2.svg";